import styled from 'styled-components'
import Text from '@/components/common/Text'
import CreativeMultiSelect from '@/components/Creatives/CreativeMultiSelect'
import BaseTextArea from '@/components/common/BaseTextArea'
import Button from '@/components/ui/Button'
import { useTranslations } from 'next-intl'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  width: 100%;
  margin-top: 12px;
`

const FeedbackModalRow = styled.div`
  display: grid;
  grid-gap: 8px 12px;
  grid-template-columns: 1fr;
`

const OptionsList = styled.div`
  max-height: 264px;
  overflow-y: auto;
  padding: 16px 2px;
`

const FeedbackModalButton = styled(Button)`
  width: 100%;
`

const optionsFirst = [
  { value: 'filters', label: 'Filters' },
  { value: 'product-demo', label: 'Product Demo' },
  { value: 'search-design', label: 'Search Design' },
  { value: 'bugs-and-freezes', label: 'Bugs and Freezes' },
  { value: 'missing-features', label: 'Missing Features' },
  { value: 'dont-understand', label: 'Don’t Understand' },
  { value: 'poor-search-results', label: 'Poor Search Results' },
  { value: 'too-expensive', label: 'Too Expensive' },
]

const optionsSecond = [
  { value: 'creative-database', label: 'Creative Database' },
  { value: 'product-demo', label: 'Product Demo' },
  { value: 'search-results', label: 'Search Results' },
  { value: 'creative-details', label: 'Creative Details' },
  { value: 'filters', label: 'Filters' },
]

const StepTwo = ({ formData, setFormData, handleNextStep }) => {
  const t = useTranslations('creatives')
  return (
    <Wrapper>
      <FeedbackModalRow>
        <Text size="16">{t('weakestPointQuestion')}</Text>
        <Text size="14">{t('multipleOptionsInfo')}</Text>
        <OptionsList>
          <CreativeMultiSelect
            list={optionsFirst}
            initialSelect={[]}
            onChange={(selected) =>
              setFormData((prevData) => ({
                ...prevData,
                weakestPoint: selected,
              }))
            }
            controlShouldRenderValue
          />
        </OptionsList>
        <Text size="14">{t('yourOptionOrDetails')}</Text>
        <BaseTextArea
          name="customField1"
          cols="10"
          value={formData.weakestPointContent}
          onChange={(e) =>
            setFormData((prevData) => ({
              ...prevData,
              weakestPointContent: e.target.value,
            }))
          }
        />
      </FeedbackModalRow>
      <FeedbackModalRow>
        <Text size="16">{t('likedAboutProduct')}</Text>
        <Text size="14">{t('multipleOptionsInfo')}</Text>
        <OptionsList>
          <CreativeMultiSelect
            list={optionsSecond}
            initialSelect={[]}
            onChange={(selected) =>
              setFormData((prevData) => ({
                ...prevData,
                aboutProduct: selected,
              }))
            }
            controlShouldRenderValue
          />
        </OptionsList>
        <Text size="14">{t('yourOptionOrDetails')}</Text>
        <BaseTextArea
          name="customField2"
          cols="10"
          value={formData.aboutProductContent}
          onChange={(e) =>
            setFormData((prevData) => ({
              ...prevData,
              aboutProductContent: e.target.value,
            }))
          }
        />
      </FeedbackModalRow>
      <FeedbackModalButton filled onClick={handleNextStep}>
        {t('btnContinue')}
      </FeedbackModalButton>
    </Wrapper>
  )
}
export default StepTwo
